import { CaseDocumentTagEnum } from '@cupoui/shared/model/case-document';
import { Injectable } from '@angular/core';
import { Adapter } from '@cupoui/shared/interfaces/adapter';

export class CaseDocumentTag {
  name: CaseDocumentTagEnum;
  public constructor(init?: Partial<CaseDocumentTag>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CaseDocumentTagAdapter implements Adapter<CaseDocumentTag> {
  adapt(item: any): CaseDocumentTag {
    return new CaseDocumentTag({
      name: item.name
    });
  }
}
